import { gql } from '@apollo/client';

export const FIND_DIVISION_DEPENDENCY = gql`
  query FindDivisionDependency($uuid: ID!) {
    findAll: findDivisionDependency(uuid: $uuid) {
      intermediates {
        name
        processAreaDependencys {
          comment
          processArea
          percentage
          processAreaUUID
          supportedRevenue
          uuid
        }
        supportedRevenue
        key: uuid
      }
      name
      processAreaDependencys {
        comment
        percentage
        processArea
        processAreaUUID
        supportedRevenue
        uuid
      }
      children: productGroupFinancials {
        name
        processAreaDependencys {
          comment
          percentage
          processArea
          processAreaUUID
          supportedRevenue
          uuid
        }
        children: productFinancials {
          name
          processAreaDependencys {
            processArea
            comment
            percentage
            processAreaUUID
            supportedRevenue
            uuid
          }
          supportedRevenue
          key: uuid
        }
        supportedRevenue
        key: uuid
      }
      supportedRevenue
      key: uuid
    }
  }
`;

export const UPSERT_PROCESS_AREA_DEPENDENCIES = gql`
  mutation UpsertProcessAreaDependencys(
    $data: CreateProcessAreaDependencysInput!
  ) {
    upsertProcessAreaDependencys(data: $data) {
      ProcessAreaDependency {
        comment
        percentage
        supportedRevenue
        uuid
      }
      processArea
      processAreaUUID
    }
  }
`;

export const UPDATE_PROCESS_AREA = gql`
  mutation UpdateProcessArea($input: UpdateProcessAreaInput!) {
    updateProcessArea(data: $input) {
      comment
      processArea
      replacementCost
      replacementTime
      underlyingProcesses
      uuid
    }
  }
`;
